import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Pencil, CreditCard, Globe, CalendarDays } from 'lucide-react';
import type { IEmployeeProfileBannerProps } from '@/@types/employee-detail';

export function EmployeeProfileBanner({ employee, onBack, onEdit }: IEmployeeProfileBannerProps) {
  const initials = employee.name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const formattedDob = employee.dateOfBirth
    ? new Date(employee.dateOfBirth).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : null;

  return (
    <div className="flex items-center gap-4 rounded-xl border border-border bg-card p-4">
      <Button variant="ghost" size="sm" onClick={onBack} className="shrink-0">
        <ArrowLeft className="h-4 w-4 mr-1" aria-hidden="true" />
        Back
      </Button>

      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-semibold text-lg">
        {initials}
      </div>

      <div className="flex flex-1 items-center gap-3 min-w-0 flex-wrap">
        <h1 className="text-xl font-semibold text-foreground truncate">{employee.name}</h1>
        <Badge variant="default">Active</Badge>

        <div className="flex items-center gap-3 text-sm text-muted-foreground flex-wrap">
          {employee.identityDocumentNumber && (
            <span className="flex items-center gap-1">
              <CreditCard className="h-3.5 w-3.5" aria-hidden="true" />
              {employee.identityDocumentNumber}
            </span>
          )}
          {employee.nationality && (
            <span className="flex items-center gap-1">
              <Globe className="h-3.5 w-3.5" aria-hidden="true" />
              {employee.nationality}
            </span>
          )}
          {formattedDob && (
            <span className="flex items-center gap-1">
              <CalendarDays className="h-3.5 w-3.5" aria-hidden="true" />
              {formattedDob}
            </span>
          )}
        </div>
      </div>

      {onEdit && (
        <Button variant="outline" size="sm" onClick={onEdit} className="shrink-0">
          <Pencil className="h-4 w-4 mr-1" aria-hidden="true" />
          Edit
        </Button>
      )}
    </div>
  );
}
